module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress', {
    attrs: {
      "size": "is-small"
    }
  }), _vm._v(" "), _c('b-progress'), _vm._v(" "), _c('b-progress', {
    attrs: {
      "size": "is-medium"
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "size": "is-large"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c661f9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/progress/examples/ExSizes.vue
// module id = 1150
// module chunks = 25 200